import { module } from 'angular';

export const SUBNET_MODULE = 'spinnaker.core.subnet.module';
module(SUBNET_MODULE, [
  require('./subnetTag.component').name,
]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/subnet/subnet.module.ts